import React from 'react';
import { Link } from 'react-router-dom';

export const Merch = () => {
  return (
    <div className='rounded-lg border border-neutral-800 bg-neutral-900 p-6 shadow-sm text-center'>
      <p className='font-body text-sm text-neutral-300'>Check out the <Link className='text-primary-light hover:text-primary-foreground underline' to='/merch'>Merch Store</Link>. Every dollar helps keep the lights on.</p>
    </div>
  )
};

export default Merch;
